'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScalableBox = require('./ScalableBox');

Object.defineProperty(exports, 'ScalableBox', {
  enumerable: true,
  get: function get() {
    return _ScalableBox.ScalableBox;
  }
});


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ScalableBox/index.js